import { render, staticRenderFns } from "./QuickAnswerDetails.vue?vue&type=template&id=6d3cd435&scoped=true"
import script from "./QuickAnswerDetails.vue?vue&type=script&lang=js"
export * from "./QuickAnswerDetails.vue?vue&type=script&lang=js"
import style0 from "./QuickAnswerDetails.vue?vue&type=style&index=0&id=6d3cd435&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3cd435",
  null
  
)

export default component.exports